import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './tailwind-fallback.css';
import App from './App';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // HTML pré-renderizado pelo react-snap: hidratar
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Sem pré-renderização: renderizar normalmente
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
